(function () {
  'use strict';

  // Bridge successful cart adds to the Google Ads add-to-cart conversion.
  var ADS_ID = 'AW-866682315';
  var ADD_TO_CART_SEND_TO = ADS_ID + '/BZL4CM3asYsBEMuLop0D';

  if (window.__lpwGoogleAdsAtcTrackingInstalled || !window.fetch) return;
  window.__lpwGoogleAdsAtcTrackingInstalled = true;

  var nativeFetch = window.fetch.bind(window);
  var gtagReady = false;
  var gtagScriptRequested = false;

  function normalizePath(path) {
    return String(path || '').replace(/\/$/, '') || '/';
  }

  function cartUrl() {
    return window.theme && theme.routes && theme.routes.cart ? theme.routes.cart : '/cart';
  }

  function cartAddUrl() {
    return window.theme && theme.routes && theme.routes.cartAdd ? theme.routes.cartAdd : '/cart/add';
  }

  function cartAddJsonUrl() {
    var path = cartAddUrl();
    return path.indexOf('.js') === path.length - 3 ? path : path + '.js';
  }

  function isCartAddPath(pathname) {
    var path = normalizePath(pathname);
    var route = normalizePath(cartAddUrl());
    return path === route || path === route + '.js' || path === '/cart/add' || path === '/cart/add.js';
  }

  function toUrl(value) {
    try {
      return new URL(value, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function requestMethod(input, init) {
    return String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
  }

  function isCartAddRequest(input, init) {
    if (requestMethod(input, init) !== 'POST') return false;

    var url = toUrl(requestUrl(input));
    return Boolean(url && url.origin === window.location.origin && isCartAddPath(url.pathname));
  }

  function customerTrackingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return true;

    try {
      if (typeof privacy.marketingAllowed === 'function' && !privacy.marketingAllowed()) return false;
      if (
        typeof privacy.analyticsProcessingAllowed === 'function' &&
        !privacy.analyticsProcessingAllowed()
      ) {
        return false;
      }
    } catch (error) {
      return false;
    }

    return true;
  }

  function requestGtagScript() {
    if (gtagScriptRequested) return;
    gtagScriptRequested = true;

    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(ADS_ID);
    script.setAttribute('data-lpw-google-ads-atc', 'true');
    document.head.appendChild(script);
  }

  function prepareGtag() {
    if (!customerTrackingAllowed()) return null;

    window.dataLayer = window.dataLayer || [];

    if (typeof window.gtag !== 'function') {
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
      requestGtagScript();
    } else if (
      !document.querySelector('script[src*="googletagmanager.com/gtag/js"]') &&
      !document.querySelector('script[src*="googletagmanager.com/gtm.js"]')
    ) {
      requestGtagScript();
    }

    if (!gtagReady) {
      window.gtag('config', ADS_ID, { send_page_view: false });
      gtagReady = true;
    }

    return window.gtag;
  }

  function firstNumber(values) {
    for (var i = 0; i < values.length; i += 1) {
      var value = Number(values[i]);
      if (Number.isFinite(value)) return value;
    }

    return null;
  }

  function centsToMoney(cents) {
    return Math.round((cents / 100) * 100) / 100;
  }

  function lineQuantity(line) {
    var quantity = Number(line.quantity);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function lineUnitValue(line) {
    var cents = firstNumber([line.final_price, line.price, line.original_price]);
    return cents === null ? 0 : centsToMoney(cents);
  }

  function lineTotalValue(line) {
    var cents = firstNumber([line.final_line_price, line.line_price]);
    if (cents !== null) return centsToMoney(cents);

    cents = firstNumber([line.final_price, line.price, line.original_price]);
    return cents === null ? 0 : centsToMoney(cents * lineQuantity(line));
  }

  function currencyCode(payload, line) {
    if (line && line.currency) return line.currency;
    if (payload && payload.currency) return payload.currency;
    if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.currency) {
      return ShopifyAnalytics.meta.currency;
    }
    if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
    return 'USD';
  }

  function productLineId(line) {
    return line.variant_id || line.variantId || line.id || line.sku || '';
  }

  function conversionItems(line) {
    var id = productLineId(line);
    var item = {
      id: String(id),
      item_id: String(id),
      item_name: line.product_title || line.title || line.name || '',
      price: lineUnitValue(line),
      quantity: lineQuantity(line),
      google_business_vertical: 'retail'
    };

    if (line.sku) item.sku = line.sku;
    if (line.product_id) item.item_group_id = String(line.product_id);

    return [item];
  }

  function payloadLines(payload) {
    if (!payload || payload.status) return [];
    if (payload.variant_id || payload.variantId || payload.id) return [payload];
    if (payload.item) return [payload.item];
    if (Array.isArray(payload.items)) return payload.items;
    return [];
  }

  function fireConversion(payload, line) {
    return new Promise(function (resolve) {
      var gtag = prepareGtag();
      if (!gtag) {
        resolve();
        return;
      }

      var finished = false;
      var timeout = window.setTimeout(done, 600);

      function done() {
        if (finished) return;
        finished = true;
        window.clearTimeout(timeout);
        resolve();
      }

      var params = {
        send_to: ADD_TO_CART_SEND_TO,
        currency: currencyCode(payload, line),
        items: conversionItems(line),
        event_callback: done,
        event_timeout: 600
      };
      var value = lineTotalValue(line);
      if (value > 0) params.value = value;

      try {
        gtag('event', 'add_to_cart', params);
      } catch (error) {
        done();
      }
    });
  }

  function trackCartAddPayload(payload) {
    var lines = payloadLines(payload);
    if (!lines.length) return Promise.resolve();

    return Promise.all(lines.map(function (line) {
      return fireConversion(payload, line);
    }));
  }

  window.fetch = function lpwGoogleAdsAtcFetch(input, init) {
    var trackResponse = isCartAddRequest(input, init);

    return nativeFetch(input, init).then(function (response) {
      if (trackResponse && response.ok) {
        response.clone().json().then(trackCartAddPayload).catch(function () {});
      }

      return response;
    });
  };

  document.addEventListener('click', function (event) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || (link.target && link.target !== '_self')) return;

    var url = toUrl(link.href);
    if (!url || url.origin !== window.location.origin || !isCartAddPath(url.pathname)) return;

    var variantId = url.searchParams.get('id');
    if (!variantId) return;

    event.preventDefault();

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', url.searchParams.get('quantity') || '1');
    url.searchParams.forEach(function (value, key) {
      if (key !== 'id' && key !== 'quantity') formData.append(key, value);
    });

    nativeFetch(cartAddJsonUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    }).then(function (response) {
      if (!response.ok) throw new Error(response.status);
      return response.json();
    }).then(function (payload) {
      return trackCartAddPayload(payload);
    }).then(function () {
      window.location.href = cartUrl();
    }).catch(function () {
      window.location.href = link.href;
    });
  });

  // Shopify's Google & YouTube channel loads the AW-866682315 container itself,
  // but it loads late. Preparing gtag on page load therefore found nothing and
  // fetched a second copy of the same container on every page view. Wait, and
  // only prepare gtag when a conversion actually needs to fire.
}());
